import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlayFrame20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconPlayFrame20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 3.5h-13a1 1 0 0 0-1 1v1h15v-1a1 1 0 0 0-1-1m-14 12V7h15v8.5a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1M3.5 2A2.5 2.5 0 0 0 1 4.5v11A2.5 2.5 0 0 0 3.5 18h13a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 16.5 2zm5.25 7.899a.25.25 0 0 1 .382-.213l3.073 1.91a.25.25 0 0 1-.004.427l-3.073 1.822a.25.25 0 0 1-.378-.215zm1.174-1.487c-1.166-.724-2.674.114-2.674 1.487v3.731c0 1.356 1.476 2.197 2.643 1.505l3.073-1.822a1.75 1.75 0 0 0 .03-2.992z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlayFrame20);
